import React from 'react';
import ReactDOM from 'react-dom';

import type { Initializer } from 'common/types/initializers';
import { Reconnect } from 'src/federation/Reconnect';

type Props = {
  node: HTMLElement;
};

export const BookableOnTreatwellBannerInitializer = ({ node }: Props): Initializer => {
  const destroy = () => ReactDOM.unmountComponentAtNode(node);

  return {
    destroy,
    render: () => {
      ReactDOM.render(<Reconnect name="BookableOnTreatwellBanner" props={{}} />, node);
    },
  };
};
